import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import css from './tag.module.less'

export type SearchTagProps = {
  onRemove: () => void
}
export default function SearchTag(props: SearchTagProps) {
  const { onRemove } = props
  return (
    <div className={css.tag}>
      <span>集内搜索</span>&nbsp;
      <Icon className={css.icon} type="m-guanbi" onClick={onRemove} />
    </div>
  )
}
